import React from 'react';
import { Tag } from 'antd';
import { arrComparer, removeDupes } from '../../../../api/util';
import { fetchJsData } from '../../../../api';
import { isArray } from 'lodash';

export const newApps = (leng, ind) => {
    return [
        {
            title: () => {
                return (
                    <>
                        URL <Tag color="processing">{leng}</Tag>
                    </>
                );
            },
            dataIndex: 'url',
            key: 'url',
            fixed: 'left',
            sorter: (a, b) => (a.url ? a.url.localeCompare(b.url) : 1),
            width: '35%',
        },
        {
            title: 'Old Categories',
            dataIndex: 'old_categories',
            key: 'old_categories',
            fixed: 'left',
            width: '25%',
            render: (text) => {
                return <>{text.includes('|') ? text.split('|').map((x) => <Tag>{x}</Tag>) : <Tag>{text}</Tag>}</>;
            },
        },
        {
            title: 'New Categories',
            dataIndex: 'new_categories',
            key: 'new_categories',
            fixed: 'left',
            width: '25%',
            render: (text) => {
                return <>{text.includes('|') ? text.split('|').map((x) => <Tag>{x}</Tag>) : <Tag>{text}</Tag>}</>;
            },
        },
        {
            title: ind,
            dataIndex: 'scheduled_date',
            key: 'scheduled_date',
            fixed: 'left',
            width: '15%',
            defaultSortOrder: 'ascend',
            sorter: (a, b) => new Date(a.scheduled_date) - new Date(b.scheduled_date),
            render: (text, record) => {
                return <>{text !== null ? text : ''}</>;
            },
        },
    ];
};

export const tabPageCss = {
    padding: '0',
    marginBottom: '0',
};

export const cardCss = { padding: '0', borderStyle: 'hidden' };
